import { VisionApplication } from '../../application';
import { VisionMap } from '../../map/map';
import { VisionSpotRockingTab } from './spot_rocking';

export class SpotRockingMap {
    map!: VisionMap;
    parent: VisionSpotRockingTab;

    public infoWindow!: google.maps.InfoWindow;

    constructor(tab: VisionSpotRockingTab) {
        this.parent = tab;
        const app = VisionApplication.getInstance();
        tab.layout.cells('b').attachHTMLString('<div id="spot_rocking_map_id" style="width:100%;height:100%"></div>');

        this.map = new VisionMap('spot_rocking_map_id');
        this.map.init('spot_rocking_map', app.organizationService.dto?.latitude, app.organizationService.dto?.longitude).then(() => {
            console.log('Spot Rocking Map Initialized');

            this.infoWindow = new google.maps.InfoWindow({
                content: "Hello, I'm a popup!",
                pixelOffset: new google.maps.Size(8, -32),
            });

            VisionApplication.getInstance().setMapWorkspace(this.map.map);
            this.map.map.setCenter(new google.maps.LatLng(app.organizationService.dto?.latitude, app.organizationService.dto?.longitude));
            this.parent.afterMapInit();
        });
    }
}
